import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

export interface CustomerCostRow {
  tenant_id: string;
  slug: string;
  name: string;
  status: string;
  tier: string;
  instances: number;
  /** Real: computed from actual droplet sizes at DO list prices. */
  infra_monthly_usd: number;
  /** Placeholder until real pricing is set (null = custom/contract). */
  plan_monthly_usd: number | null;
  margin_monthly_usd: number | null;
}

export interface CostsResponse {
  pricing_is_placeholder: boolean;
  customers: CustomerCostRow[];
  totals: {
    infra_monthly_usd: number;
    revenue_monthly_usd: number;
    margin_monthly_usd: number;
    priced_customers: number;
    unpriced_customers: number;
  };
}

export function useCosts() {
  return useQuery({
    queryKey: ['costs'],
    queryFn: () => apiFetch<CostsResponse>('/costs'),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
